import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Chart from 'react-apexcharts'

import { get } from 'lodash'

import { PortalLayout } from '../../components'
import LayoutImageBg from '../../../../assets/images/farmer-portal-reports.png'
import ReportIcon from '../../../../assets/images/productivity-report.png'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'

import './Styles.css'

const PopulationVariety = ({ history, location }) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [report, setReport] = useState([])
  const [varieties, setVarieties] = useState([])
  const [qttLocations, setQttLocations] = useState('0')

  useLayoutEffect(() => {
    if (!currentUser) {
      return history.push('/farmers/portal')
    }
  }, [])

  useEffect(() => {
    const { material } = get(location, 'state')
    const city = JSON.parse(sessionStorage.getItem('selected_city')) || {}

    const { macroRegion, microRegion } = city

    fetchReport({ macroRegion, microRegion, materialsI2x: [material] })
  }, [])

  useEffect(() => {
    countLocations()
  }, [])

  async function countLocations() {
    const { count = 0 } = await request(api.countLocations())
    setQttLocations(new Intl.NumberFormat('pt-BR').format(count))
  }

  async function fetchReport(filters) {
    const { populationByMaterial = [] } = await request(api.dashboardFarmerPortal(filters))

    if (populationByMaterial.length === 0) return

    const varietyList = []
    const populations = []

    populationByMaterial.reverse().forEach((item) => {
      varietyList.push(item.material)
      populations.push(parseInt(item.population))
    })

    setReport([
      {
        data: populations
      }
    ])
    setVarieties(varietyList)
  }

  const options = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      }
    },
    colors: ['#843EF7', '#369EFF', '#04D1D1', '#BF55DA', '#843EF7'],
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#843EF7', '#369EFF', '#04D1D1', '#BF55DA', '#843EF7']
      }
    },
    stroke: {
      show: false
    },
    tooltip: {
      enabled: false
    },
    legend: {
      show: false
    },
    xaxis: {
      categories: varieties
    }
  }

  return (
    <PortalLayout
      bgImage={LayoutImageBg}
      centerImage={ReportIcon}
      title="Resultados do relatório"
      subtitle={getMessage('farmer.portal.population.variety')}
      showAction
    >
      <div className="population-variety">
        <div className="wrapper">
          <p className="title">{getMessage('farmer.portal.population.variety')}</p>
          <p className="subtitle">
            Os dados informados são relacionados a safra 2021/2022 e de um total de {qttLocations} agricultores
          </p>

          <div className="chart-box">
            <Chart options={options} series={report} type="bar" height="350" />
          </div>
        </div>
      </div>
    </PortalLayout>
  )
}

export default PopulationVariety
